import { useEffect } from "react"

/**
 * Adds `.is-visible` to any `[data-reveal]` element when it scrolls into view.
 *
 * Pair with the CSS in `<EditorialStyles />` (from `@/components/public/editorial`)
 * which handles the actual fade-up transition.
 *
 * Used by the boutique-secret-weapon LP, the homepage, and any future page
 * that adopts the editorial-cinematic design system.
 */
export function useEditorialReveal() {
  useEffect(() => {
    const els = document.querySelectorAll<HTMLElement>("[data-reveal]")
    if (els.length === 0) return

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible")
            observer.unobserve(entry.target)
          }
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -50px 0px" },
    )

    els.forEach((el) => observer.observe(el))
    return () => observer.disconnect()
  }, [])
}
